interface IMenuItemHiddenTextLabelProps {
  children?: React.ReactNode;
}

// This is a hack that will add a hidden `-` to the beginning of the menu item label.
// This will ensure that the menu does not take precendence when typing characters when the menu is visible,
// specifically when trying to interact with an input field (ie: ReExtract)
const MenuItemHiddenTextLabel = ({ children }: IMenuItemHiddenTextLabelProps) => {
  return (
    <>
      <span style={{ fontSize: '1px' }}>-</span>
      {children}
    </>
  );
};

export default MenuItemHiddenTextLabel;
